import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { Navbar } from "react-bootstrap";

import MoonIcon from "../images/moon.svg";

const Header = ({ siteTitle }) => (
  <Navbar bg="dark" variant="dark" expand="xxl">
    <Navbar.Toggle aria-controls="main-menu">
      <img src={MoonIcon} alt="Moon also used as menu trigger" />
    </Navbar.Toggle>
    <Navbar.Collapse id="main-menu" expand="xxl">
      <Link to="/" className="nav-link">Home</Link>
      <span class="navbar-text mt-3">Case Studies</span>
      <Link to="/faster-fit-case-study" className="nav-link">Faster.fit</Link>
      <Link to="/footprints-case-study" className="nav-link">Footprints</Link>
      <Link to="/network-insights-case-study" className="nav-link">Network Insights</Link>
      <Link to="/careers" className="nav-link mt-3">Careers</Link>
      <Link to="/about" className="nav-link">About Us</Link>
      <div className="spacer" style={{height: "100vh"}}/>
    </Navbar.Collapse>
  </Navbar>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
